export type LayerOrderEntry = {
  FeatureCode: string
  Priority: number
}

/**
 * Computes the minimal set of Priority rewrites that realizes a new total
 * order. Takes the layers in their NEW order, ascending (first = lowest rank
 * = drawn first / bottom of the map), each carrying its CURRENT Priority.
 * Walks the list keeping every rank that is already strictly increasing and
 * bumps only the ones that are not — a single drag usually touches a handful
 * of rows, not the whole catalog.
 */
export function computeOrderUpdates(
  orderedAscending: LayerOrderEntry[],
): LayerOrderEntry[] {
  const updates: LayerOrderEntry[] = []
  let previousPriority = 0
  for (const layer of orderedAscending) {
    if (layer.Priority > previousPriority) {
      previousPriority = layer.Priority
      continue
    }
    previousPriority += 1
    updates.push({ FeatureCode: layer.FeatureCode, Priority: previousPriority })
  }
  return updates
}
